import React, { Component } from 'react';
import './Footer.css'

declare var $;

class Footer extends Component {
  constructor(props) {
    super(props)
    this.state  = {
      showCallto: true,
      style : 'slideInUp',
      callToMargin: false
    }
    this.VerifyIos = this.VerifyIos.bind(this)
    this.clickContinue = this.clickContinue.bind(this)
  }

  componentDidMount() {
    this.VerifyIos()
  }
  componentWillMount() {
    let callto = $('#callto');
    let $win = $(window);
    let winH = $win.height();
    $win.on("scroll", () => {
       if ($win.scrollTop() > 200 ) {
           this.setState({
             style: 'slideOutDown',
           })
       } else {
         this.setState({
           style: 'slideInUp',
           showCallto: true,
         })
       }
   })
  }
  goDown() {
    $.scrollTo($("#question") ,1000);
  }

  clickContinue() {
    let step = this.props.step + 1
    this.props.continue(step)
  }

  VerifyIos() {
    let ua = navigator.userAgent || navigator.vendor;
    let standalone = window.navigator.standalone
    let userAgent = window.navigator.userAgent.toLowerCase()
    let safari = /safari/.test( userAgent )
    let ios = /iphone|ipod|ipad/.test( userAgent );

    if( ios && ( (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1) ) ) {
      this.setState({
        callToMargin: true
      })
    }
  }

  render() {
    return (
      <div className="call-to-action">
        <a onClick={this.clickContinue} className="waves-effect waves-light btn">{this.props.text}</a>
      </div>
    );
  }
}


export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/Footer.js